import React from "react";
import axios from "axios";

export const updateApplicationApi = async (id,token,data) => {

  try {
    const options = {
      method: "DELETE",
      url : `https://visapro.herokuapp.com/api/v1/applications/${id}/cancel`,
      headers: {
        'Authorization': `Basic ${token}` 
      },
    };
    const response = await axios.request(options)
    const update = {
      data: response.data,
    };
    return update;
  } catch (error) {
    const update = {
      error: error,
    };
    return update;
  }
};
